export const QBO_MESSAGE = 'QBO Response';

export const SUCCESSFUL_REDIRECT = 'Credentials saved successfully';
export const FAILURE_REDIRECT = 'Something went wrong. Please try again';
